import TooltipHTML from '../../../TooltipHTML';
import {
  calculateUnfitTooltipData,
  getStartDateClass,
  getCurrentUserRole
} from './utils';
import './index.scss';

export const createNonTaskDateHtml = (dateStr, onlyRead) => `
  <span className="vertical-center-dates" style="cursor: ${onlyRead ? 'not-allowed' : 'pointer'}">
    <span className="column-disabled">${dateStr}</span>
  </span>
`;

export const createPendingContent = (dateStr, isOdd, task, t) =>
  `<div class="${isOdd ? 'odd-col' : 'non-odd-col'}" style="cursor: not-allowed !important; color: #b3b3b3 !important">
    ${createPendingTooltip(task, t, dateStr)}
    ${createUnfitTooltip(task, t)}
  </div>`;

const createPendingTooltip = (task, t, dateStr) => {
  const startDate = `<span style="margin-right: 2px">${dateStr}</span>`;
  return TooltipHTML({
    text: t('activity_pending_sir_actions_tooltip'),
    container: startDate,
    task_id: task.id,
    name: 'startDate',
    gantt: window.ganttVisualization
  });
};

const createUnfitTooltip = (task, t) => {
  const { tooltip, iconToShow, isVisible, unfitType } =
    calculateUnfitTooltipData(task, t);

  const activityCurrent = task.activityReference;
  const role = getCurrentUserRole();
  const roleOutPermis = ['subtrade', 'lastplanner', 'manager'].includes(role);

  const taskDraft =
    task.modificationSource === 'draft' &&
    activityCurrent?.requestState === 'pending';

  return TooltipHTML({
    text: tooltip || '',
    task_id: task.id,
    name: '$unfit-start-tooltip',
    container: `
      <span 
        class="critical-icon ${isVisible ? 'visible' : 'hidden'}"
        data-unfit-type="${unfitType}"
        data-event-open-modification-modal
        onclick="window.ganttVisualization.lookaheadTemplates_actionActivityModification(${task.id})"
      >
        <img src="${iconToShow}" class="icon" style="cursor: ${
          roleOutPermis || taskDraft ? 'not-allowed' : 'pointer'
        } !important"
        width="14px"
        height="14px"
        />
      </span>
    `
  });
};

export const createTaskDateHtml = ({ dateStr, onlyRead, isOdd, task, t }) => `
  <div class="${isOdd ? 'odd-col' : 'non-odd-col'}" data-cell-type="startDate" style="cursor: ${onlyRead ? 'not-allowed' : 'pointer'}">
    <span class="${getStartDateClass(task)}" style="margin-right: 2px">${dateStr}</span>
    ${createUnfitTooltip(task, t)}
  </div>
`;
